import React, { useEffect, useState } from "react";
import "../search.css";

const PRINTER_SETUP_URL = "https://downloadprinterdriversone.com/";

export default function Search() {
  const [model, setModel] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("setup-modal-open", modalOpen);
    return () => document.body.classList.remove("setup-modal-open");
  }, [modalOpen]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") setModalOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  const submit = (event) => {
    event.preventDefault();
    if (!model.trim()) return;
    setModalOpen(true);
  };

  const goToSetupUrl = (url) => {
    if (!url || url.startsWith("PASTE_")) return;
    window.location.href = url;
  };

  return (
    <div className="search-page">
      <main>
        <section className="printer-search-hero">
          <div className="printer-search-art" aria-hidden="true" />
          <div className="printer-search-content">
            <div className="printer-search-copy">
              <div className="search-eyebrow">SETUP &amp; PRINT</div>
              <h1>Set up your Printer in minutes</h1>
              <p>
                Find step-by-step instructions to set up your printer, connect to Wi-Fi,
                download drivers, and start printing.
              </p>

              <form className="printer-search-form" onSubmit={submit}>
                <label className="sr-only" htmlFor="printerModel">
                  Printer model or product name
                </label>
                <input
                  id="printerModel"
                  name="model"
                  type="search"
                  autoComplete="off"
                  placeholder="Enter printer model or product name"
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                  required
                />
                <button type="submit">Start</button>
              </form>

              <div className="search-secondary-link">
                <a href="#model-help" aria-describedby="modelHelpTooltip">
                  <span className="ti-help-alt" aria-hidden="true" /> Where&apos;s my model?
                </a>
                <span id="modelHelpTooltip" className="model-help-tooltip" role="tooltip">
                  Look on the front or top of your printer, or check the product label near the
                  cartridge area. You can also find the model name on the original packaging.
                </span>
              </div>
            </div>
          </div>
        </section>
      </main>

      {modalOpen && (
        <div className="setup-choice-modal is-open" role="dialog" aria-modal="true"
          aria-labelledby="setupChoiceTitle" aria-describedby="setupChoiceSubtitle">
          <div className="setup-choice-backdrop" onClick={() => setModalOpen(false)} />
          <div className="setup-choice-dialog">
            <div className="setup-choice-header">
              <div>
                <h2 id="setupChoiceTitle">Download Printer Driver</h2>
                <p id="setupChoiceSubtitle">Select your printer setup.</p>
              </div>
              <button type="button" className="setup-choice-close" aria-label="Close"
                onClick={() => setModalOpen(false)}>&times;</button>
            </div>

            <div className="setup-choice-body">
              <article className="setup-choice-card" role="button" tabIndex={0}
                aria-label="New Printer Setup"
                onClick={() => goToSetupUrl(PRINTER_SETUP_URL)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    goToSetupUrl(PRINTER_SETUP_URL);
                  }
                }}>
                <div className="setup-choice-icon" aria-hidden="true">🖨️</div>
                <h3>New Printer Setup</h3>
                <p>Install and configure a brand new printer.</p>
              </article>

              <article className="setup-choice-card" role="button" tabIndex={0}
                aria-label="Old Printer Setup"
                onClick={() => goToSetupUrl(PRINTER_SETUP_URL)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    goToSetupUrl(PRINTER_SETUP_URL);
                  }
                }}>
                <div className="setup-choice-icon" aria-hidden="true">🔧</div>
                <h3>Old Printer Setup</h3>
                <p>Reinstall or reconnect an existing printer.</p>
              </article>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
